import { put, call } from 'redux-saga/effects';

import {
  loginService,
  editProfileService,
  logoutService,
  permissionsService,
  getLoggedUserService,
} from 'services';
import { putNotifySuccess } from 'shared/functions';
import {
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_ERROR,
  LOGOUT_SUCCESS,
  PERMISSIONS,
  GET_LOGGED_USER_SUCCESS,
} from './loginAction';

export function* loginSaga(payload) {
  try {
    const loginResponse = yield call(loginService, payload);

    if (loginResponse.token) {
      const permissionsResponse = yield call(permissionsService, loginResponse);

      yield put({ type: LOGIN_SUCCESS, response: loginResponse });
      yield put({ type: PERMISSIONS, response: permissionsResponse });
    } else {
      throw loginResponse;
    }
  } catch (error) {
    yield put({ type: LOGIN_ERROR, response: error });
  }
}

export function* getLoggedUserSaga(payload) {
  const response = yield call(getLoggedUserService, payload);
  yield put({ type: GET_LOGGED_USER_SUCCESS, response });
}

export function* logoutSaga() {
  try {
    yield call(logoutService);
    if (process.env.REACT_APP_ENV === 'production') {
      FS.anonymize();
    }
  } finally {
    yield put({ type: LOGOUT_SUCCESS });
    yield putNotifySuccess('Successful logout.');
  }
}

export function* editProfileSaga(payload) {
  try {
    const response = yield call(editProfileService, payload);
    yield put({ type: EDIT_PROFILE_SUCCESS, response: response.data });
  } catch (response) {
    yield put({ type: EDIT_PROFILE_ERROR, response });
  }
}
